// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/new-letter-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Theme */
/* * {
  font-family: sans-serif, "Poppins";
} */
:root {
  --Primary-Color-Dark-000639: #000639;
  --Primary-Color-hover-202E78: #202e78;
  --Primary-Color-brand-5C6ACA: #5c6aca;
  --Primary-Color-Light-B3BCF5: #b3bcf5;
  --Primary-Color-Light-F4F5FA: #f4f5fa;
  --Secondary-27D4AB: #27d4ab;
  --Secondary-FFC960: #ffc960;
  --Secondary-FF55A7: #ff55a7;
  --Secondary-AE60EB: #ae60eb;
  --Error-FF0000: #ff0000;
  --Error-FFB2B2: #ffb2b2;
  --Secondary-FF55A7: #ff55a7;
  --Secondary-AE60EB: #ae60eb;
  --yellow: #ffc960;
  --yellowlight: #ffe4b0;
  --teal: #ccfff3;
  --white: #fff;
  --gray0: #f9fafb;
  --gray1: #f4f6f8;
  --gray2: #dfe4e8;
  --gray3: #cacdd5;
  --gray: #919eab;
  --gray-darklight: #637381;
  --gray-dark: #454f5b;
  --gray-darkblack: #212b35;
  --secondary: #6c757d;
  --success: #27d4ab;
  --info: #17a2b8;
  --warning: #ffc107;
  --danger: #dc3545;
  --light: #f8f9fa;
  --dark: #212b35;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #86b7fe;
  outline: 0;
  box-shadow: none;
}
/* .img-fluid{
  width: 100% !important;
} */
placeholder {
  color: #919eab !important;
  font-size: 12px !important;
}
body {
  background-color: var(--white) !important;
}
.bg {
  background-color: var(--gray1) !important;
}
/* Logo */
.logo {
  color: var(--white);
  font-size: 36px;
  font-weight: 600;
  text-align: center;
  padding: 5px;
  margin-left: 7px;
}
/* Right Navbar */
.rightside-bar {
  max-width: 249px;
  border-right: 1px solid #dfe4e8;
  background: var(--Primary-Color-Dark-000639);
  height: 100vh;
}
.maincontain-width {
  width: calc(100% - 249px);
}
.sidemenuicon {
  width: 24px;
  height: 24px;
}
.sidemenuicon-bell {
  width: 20px;
  height: 18px;
}
.sidebar a {
  text-decoration: none;
  font-size: 16px;
  color: var(--white);
  display: block;
  padding: 20px;
  border-radius: 6px;
  stroke: var(--white);
  font-weight: 500;
  fill: var(--white);
}
.sidebar a:hover {
  color: var(--Primary-Color-Dark-000639);
  background-color: var(--white);
  border-radius: 6px;
  fill: var(--Primary-Color-Dark-000639);
  stroke: var(--Primary-Color-Dark-000639);
}
.sidebar .active {
  color: var(--Primary-Color-Dark-000639);
  background-color: var(--white);
  border-radius: 6px;
  fill: var(--Primary-Color-Dark-000639);
  stroke: var(--Primary-Color-Dark-000639);
  padding: 3px 0px;
}
.event {
  fill: none !important;
}
.sidebar-notifi {
  background-color: var(--Secondary-27D4AB);
  color: #000639;
  font-size: 11px;
  font-weight: 600;
}
/* Top Nav */
.topnavbar {
  /*   height: 70px; */
  background-color: var(--white);
  border-bottom: #dadada 1px solid;
}
.bell-icon-container {
  position: relative;
}
.topnavbar-icon {
  width: 28px;
  height: 28px;
}
.topnavbar-icon-bell {
  width: 28px;
  height: 28px;
  cursor: pointer;
}
.notification-count {
  position: absolute;
  top: -5px;
  right: -5px;
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 3px 6px;
  font-size: 12px;
}
/* Main containt */
.main-contian {
  padding: 20px;
}
.year-select {
  width: 120px;
}
.total-v-card {
  /* max-width: 350px;  */
  width: 100%;
  
}
.total-v-card h6 {
  color: #454f5b;
  font-size: 15px;
  font-weight: 500;
  margin: 0px;
}
.total-v-card h1 {
  color: #212b35;
  font-size: 15px;
  font-weight: 600;
}
.bg-organize {
  border-radius: 6px;
  background: rgba(197, 253, 240, 0.6);
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
}
.organize-icon {
  width: 28px;
  height: 28px;
}
.revenue-icon {
  width: 35px;
  height: 35px;
}
.t-event {
  background: #fae4b9 !important;
}
.t-participants {
  background: #ffd2e7 !important;
}
.t-reg-participnts {
  background: rgba(174, 96, 235, 0.5) !important;
}
.t-event-cancel {
  background: #ddfef6 !important;
}
.t-revenue {
  background: #fae4b8 !important;
}
.bashboard-table {
  border: solid 1px #cacdd5;
  background: #fff;
}
.bashboard-table th {
  padding: 15px;
  background: #f4f6f8;
  color: #637381;
  font-size: 16px;
  font-weight: 500;
}
.bashboard-table td {
  padding: 15px;
}
.bashboard-table .id {
  color: #5c6aca;
  font-size: 14px;
}
.bashboard-table .sale {
  color: #212b35;
  font-size: 14px;
}
.bashboard-table .e-date {
  color: #637381;
  font-size: 14px;
}
.bashboard-table .e-status {
  color: #919eab;
  font-size: 14px;
}
.bashboard-table .e-ongoing {
  color: #27d4ab;
  font-size: 14px;
}
.bashboard-pagination {
  --bs-pagination-border-width: none;
  --bs-pagination-hover-bg: none;
}
.page-link:focus {
  z-index: 3;
  color: none;
  background-color: none;
  outline: 0;
  box-shadow: none;
}
.pagination-link ul {
  position: relative;
}
.pagination-link li a {
  border-radius: 6px;
  border: 0.5px solid #cacdd5;
  background: #f9fafb;
  color: #212b35;
}
.pagination-link li a:hover {
  background: #5c6aca;
  color: #f4f6f8;
}
.pagination-link li:first-child a {
  border: none;
  background: none;
  color: #212b35;
}
.pagination-link li:last-child a {
  border: none;
  background: none;
  color: #212b35;
}
.logout-icon {
  position: absolute;
  width: 215px;
}
/* .table-striped > tbody > tr:nth-child(2n+2) > td, .table-striped > tbody > tr:nth-child(2n+2) > th {
  background-color: #DFE4E8;
}
.table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
  background-color: #ffffff !important;
} */
/* organizer landing page */
.create-even {
  border-radius: 4px;
  background: #202e78;
  padding: 6px 16px;
  align-items: center;
  font-size: 14px;
  color: #fff;
  font-weight: 500;
}
.create-even:hover {
  border-radius: 4px;
  background: #5c6aca;
  padding: 6px 16px;
  align-items: center;
  font-size: 14px;
  color: #fff;
  font-weight: 500;
}
.search-bg {
  background: #f4f6f8;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  font-size: 14px;
}
.search-button-bg {
  background: #f4f6f8;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.search-bg:hover,
.search-button-bg:hover {
  background: #f4f6f8;
}
.search-bg:active,
.search-button-bg:active {
  background: #f4f6f8 !important;
}
.search-bg:focus {
  background: #f4f6f8 !important;
}
.search-input {
  width: 350px !important;
}
.all-city {
  font-size: 12px;
  color: #000;
  font-weight: 500;
}
.all-city svg {
  width: 25px;
  height: 25px;
}
/* Hader End */
/* Banner */
.topmargin {
  margin-top: 91px;
}
.banner {
  background: #130929;
  padding: 40px 0px;
}
.swiper {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.swiper-slide img {
  display: block;
  max-width: 1200px;
  width: 100%;
}
.swiper-pagination-bullet-active {
  opacity: var(--swiper-pagination-bullet-opacity, 1);
  background: #fff;
}
.swiper-pagination-bullet {
  width: var(
    --swiper-pagination-bullet-width,
    var(--swiper-pagination-bullet-size, 8px)
  );
  height: var(
    --swiper-pagination-bullet-height,
    var(--swiper-pagination-bullet-size, 8px)
  );
  display: inline-block;
  border-radius: var(--swiper-pagination-bullet-border-radius, 50%);
  background: #fff;
  opacity: 0.5;
}
.view-text {
  font-size: 12px !important;
  font-weight: 400;
  padding: 7px;
}
.card {
  border-radius: 0.5rem !important;
}
.cat-name {
  font-size: 24px;
  font-weight: 500;
  margin-left: 25px;

}
.event-card-body h6 {
  font-size: 18px;
  font-weight: 600;
}
.event-card-body .card-text {
  font-size: 14px;
  font-weight: 400;
  color: #757575;
}
.event-t-boder {
  border-top: #ababab dashed 0.5px;
}
.event-card-body .card-text-b {
  color: #4570de;
}
.event-buy-price {
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
.event-buy-price span {
  font-size: 14px;
  font-weight: 600;
}
.event-buy-ticket {
  background: #020202;
}
.news-letter {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  color: #fff;
  border-radius: 12px;
}
.social-icon a,
svg {
  color: #000;
}
.social-icon a:hover {
  color: #6b21c8;
}
.subscribe-letter-text {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}
.subscribe-letter-message {
  color: #fff;
  font-size: 16px;
  padding: 20px 80px;
  font-weight: 500;
}
.subscribe-letter-text input {
  background: #e2e2e2;
}
.subscribe-letter-btn {
  background: #ff42ca;
  color: #000;
  padding: 5px 30px;
  font-size: 30px;
}
.subscribe-letter-btn:hover {
  background: #6b21c8;
  color: #000;
  padding: 5px 30px;
  font-size: 30px;
}
.footer-info {
  color: #757575;
  font-size: 14px;
  height: 76.315px;
}
.footer-text,
.footer-text a {
  font-size: 14px;
  color: #757575;
  text-decoration: none;
}
.footer-text-h {
  font-size: 14px;
}
.pre-btn {
  color: #000;
  z-index: 1;
  float: left;
  width: auto;
  margin: auto;
  margin-left: -20px;
  padding: 0px;
}
.pre-btn-bg {
  background: #dfe4e8;
  border: 1px solid #dfe4e8;
}
.next-btn {
  color: #000;
  z-index: 1;
  float: right;
  width: auto;
  margin: auto;
  margin-right: -20px;
  padding: 0px;
}
/* detail page */
.game-name {
  font-size: 24px;
  font-weight: 600;
}
.event-cat {
  background: #bbd6ff;
  padding: 5px 10px;
  font-weight: 500;
  color: #0c3b83;
  border-radius: 4px;
}

.event-cat1 {
  background: #bbd6ff;
  padding: 20px 0;
  font-weight: 500;
  color: #0c3b83;
  border-radius: 4px;
  font-size: 13px;
  display: inline-block;
}

.accordion-detail .accordion-icon {
  background: #bbd6ff;
  border-radius: 50%;
  padding: 8px;
  font-weight: 500;
}
.accordion-detail h1 {
  font-size: 16px;
  font-weight: 500;
}
.accordion-detail .accordion-body {
  color: #000;
  font-size: 16px;
  font-weight: 400;
}
.menu-list-group-item {
  color: #000;
  font-size: 14px;
  font-weight: 400;
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: #fbfcff;
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0
    var(--bs-accordion-border-color);
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: none;
}
.detail-price-card {
  background: #f4f6f8;
  border-radius: 8px;
}
.detail-price-card .price {
  background: #fff;
  border-radius: 8px;
  padding: 10px 20px;
}
.detail-eventinfo-card {
  background: #fff;
  border-radius: 8px;
}
.detail-price-card .book-btn,
.detail-eventinfo-card .book-btn {
  border-radius: 8px;
  padding: 8px 20px;
  font-size: 18px;
  font-weight: 500;
}
.detail-price-card .book-btn:hover,
.detail-eventinfo-card .book-btn:hover {
  border-radius: 8px;
  padding: 9px 20px;
  background: #0d6efd;
  border: #0d6efd;
}
.detail-eventinfo-card h1 {
  color: #212b35;
  font-size: 14px;
  font-weight: 500;
}
.detail-eventinfo-card p {
  color: #637381;
  font-size: 12px;
  font-weight: 500;
}
/* Select Event before selection page */
.event-banner-card {
  border-radius: 6.656px;
  border: 1px solid #dfe4e8;
  background: #f9fafb;
  padding: 10px;
}
.event-banner-card h1 {
  color: #000;
  font-size: 20px;
  font-weight: 600;
}
.event-banner-card p {
  color: #636262;
  font-size: 18px;
  font-weight: 600;
}
.event-type .name {
  color: #000;
  font-size: 16px;
  font-weight: 500;
}
.event-type .price {
  color: #000;
  font-size: 18px;
  font-weight: 600;
}
.select-event-cat {
  background: #bbd6ff;
  padding: 10px 10px 10px 10px;
  font-weight: 600;
  color: #0c3b83;
  border-radius: 4px;
  font-size: 20px;
  width: 80px;
}
.event-price-summary {
  font-size: 14px;
}
.event-price-summary p {
  font-size: 11px;
}
.select-btn {
  padding: 10px 40px;
}
.accordion-detail .accordion-body {
  font-size: 16px !important;
  line-height: 2;
}
.user-detailform .card {
  padding: 5% 5%;
}
.user-detailform form,
.user-detailform .input-group-text,
.user-detailform .form-select {
  font-size: 14px;
}
.user-detailform input {
  font-size: 14px;
}
/* org */
.org-left-overbg {
  background-color: rgba(179, 188, 245, 0.1);
  border-radius: 8px;
}
.org-main-contain {
  background: #f4f6f8;
  padding: 2% 3%;
}
.org-main-contain .form-control {
  font-size: 12px;
  padding: 10px;
}
.org-main-contain .form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown),
.form-floating > .form-control:focus,
.form-floating > .form-control:not(:placeholder-shown) {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.org-main-right {
  background: #fff;
  padding: 20px;
}
.org-btn-pro {
  background: #fff;
  color: #637381;
  padding: 15px;
}
.org-btn-pro:hover {
  background: #5c6aca;
  color: #e6e6e6;
}
.org-btn-pro.active {
  background: #5c6aca;
  color: #e6e6e6;
}
.org-left-overbg .accordion-item {
  color: var(--bs-accordion-color);
  background: none !important;
  border: none !important;
}
.org-left-overbg .menu-list-group-item {
  color: #f9fafb;
  font-size: 14px;
  font-weight: 400;
}
.org-left-overbg .list-group-item {
  background: none !important;
  border-bottom: rgba(179, 188, 245, 0.3) solid 0.1px;
  border-radius: 0px;
}
.org-left-overbg .accordion-button {
  background: none;
  color: #f9fafb;
  fill: #fff;
}
.org-left-overbg .accordion-button:hover {
  background: #fff;
  color: #000;
  fill: #000;
}
.accordion-button:not(.collapsed)::after {
  /* background-color: #d2153d; */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  transform: rotate(180deg);
}

.accordion-button.collapsed::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.org-left-overbg .accordion {
  --bs-accordion-border-color: var(--bs-border-color);
  opacity: 0.5;
}
.accordion-body .list-group a:hover {
  color: #5c6aca !important;
}
.accordion-body .list-group a.active {
  color: #5c6aca !important;
}
.event-proce {
  color: #212b35;
  font-weight: 500;
  font-size: 14px;
}
.event-proce span {
  padding: 10px 18px;
  border-radius: 50%;
  background: #fff;
  color: #212b35;
  font-weight: 600;
  font-size: 16px;
}
.event-proce .green-b {
  border: #27d4ab 2px solid;
  padding: 10px 17px;
}
.event-proce .completed {
  padding: 10px 14px;
  border-radius: 50%;
  background: #27d4ab;
  color: #212b35;
  font-weight: 600;
}
.select-sport {
  border: #27d4ab solid 2px;
  padding: 3px;
  border-radius: 14px;
}
.select-sport img {
  /* width: 100%; */
}
.select-upload .bi::before,
[class*=" bi-"]::before,
[class^="bi-"]::before {
  font-weight: 600 !important;
  font-size: 20px;
}
.btn-select {
  background: #000639;
  padding: 15px;
  color: #fff;
}
.btn-select:hover {
  background: #5c6aca;
  color: #fff;
}

@media (max-width: 575.98px) {
  .banner {
    margin-top: 130px;
  }
  .cat-name {
    font-size: 16px;
    font-weight: 500;
    margin-left: 25px;

  }
  .event-card-body h6 {
    font-size: 14px;
    font-weight: 600;
  }
  .event-card-body .card-text {
    font-size: 12px;
    font-weight: 400;
    color: #757575;
  }
  .search-input {
    width: 100% !important;
  }
  .all-city {
    font-size: 8px; /*ak-10px;*/
    color: #000;
    font-weight: 500;
    padding: 3px !important;
    margin: 0px !important;
  }
  .all-city svg {
    width: 20px;
    height: 20px;
  }
  .select-btn {
    padding: 10px 10px !important;
  }
  .detail-price-card .book-btn,
  .detail-eventinfo-card .book-btn {
    font-size: 14px;
  }
  .accordion-detail .accordion-body {
    font-size: 12px !important;
    line-height: 2;
  }
  .accordion-detail h1 {
    font-size: 12px;
    font-weight: 500;
  }
  .game-name {
    font-size: 14px !important;
    font-weight: 600;
  }
  .running-details {
    font-size: 14px !important;
  }
}

@media (max-width: 767.98px) {
  .maincontain-width {
    width: calc(100% - 197px);
  }
  .offcanvas-body .float-end {
    float: none !important;
  }
  .offcanvas-body .d-flex {
    display: block !important;
  }
  .cat-name {
    font-size: 14px;
    font-weight: 500;
    margin-left: 25px;

  }
  .event-card-body h6 {
    font-size: 12px;
    font-weight: 600;
  }
  .topmargin {
    margin-top: 130px;
  }
  .subscribe-letter-text {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }
  .subscribe-letter-message {
    color: #fff;
    font-size: 16px;
    padding: 10px 20px;
    font-weight: 500;
  }

  .event-cat1 {
    background: #bbd6ff;
    padding: 10px 20px;
    font-weight: 500;
    color: #0c3b83;
    border-radius: 4px;
    font-size: 13px;
    /* display: inline-block; */    
    margin-left: 10px;
  }
}

@media (max-width: 991.98px) {
  .maincontain-width {
    width: calc(100% - 220px);
  }
  .subscribe-letter-text {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }
  .subscribe-letter-message {
    color: #fff;
    font-size: 16px;
    padding: 10px 20px;
    font-weight: 500;
  }
  .event-banner-card h1 {
    color: #000;
    font-size: 14px;
    font-weight: 600;
  }
  .event-banner-card p {
    color: #636262;
    font-size: 12px;
    font-weight: 600;
  }
  .event-type .name {
    color: #000;
    font-size: 11px;
    font-weight: 500;
  }
  .event-type .price {
    color: #000;
    font-size: 14px;
    font-weight: 600;
  }
  .select-event-cat {
    font-size: 18px;
    width: 60px;
  }
  .select-btn {
    padding: 10px 20px;
  }
}

@media (max-width: 1199.98px) {
  .sidebar a {
    font-size: 0.875rem;
    padding: 10px;
  }
  .total-v-card h6 {
    font-size: 0.8rem;
  }
  .total-v-card h1 {
    font-size: 0.875rem;
  }
  .main-contian {
    padding: 10px;
  }
  .maincontain-width {
    width: calc(100% - 249px);
  }
}
@media (max-width: 1399.98px) {
  .detail-price-card .book-btn,
  .detail-eventinfo-card .book-btn {
    font-size: 14px;
  }
  .game-name {
    font-size: 16px;
    font-weight: 600;
  }
  .accordion-detail h1 {
    font-size: 14px;
    font-weight: 500;
  }
  .accordion-detail .accordion-body {
    font-size: 14px !important;
    line-height: 2;
  }
}

@media (min-width: 1399.98px) {
  .topmargin {
    margin-top: 91px;
  }
}
.otp-form .form-control-01 {
  display: block;
  width: 40px;
  text-align: center;
  font-size: 1rem;
  padding: 10px 0px;
}
.otp-form .form-control-01:focus-visible,
.form-control-01:focus {
  border: #86b7fe 1px solid !important;
  outline: none;
}

.editor-container {
  height: 300px;
  min-height: 300px;
  /* max-height: 500px; 25px per line * 5 lines */
  overflow-y: auto; /* Add scrollbar if content exceeds max height */
}

.ql-container {
  /* height: calc(100% - 42px);  */
  height: 300px;
}
`, "",{"version":3,"sources":["webpack://./src/css/custom.css"],"names":[],"mappings":"AAAA,UAAU;AACV;;GAEG;AACH;EACE,oCAAoC;EACpC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,qBAAqB;EACrB,UAAU;EACV,gBAAgB;AAClB;AACA;;GAEG;AACH;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA,SAAS;AACT;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4CAA4C;EAC5C,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,wCAAwC;AAC1C;AACA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,YAAY;AACZ;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,gCAAgC;AAClC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,kBAAkB;AAClB;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,WAAW;;AAEb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;;;;;GAKG;AACH,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,0CAA0C;EAC1C,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,yCAAyC;AAC3C;AACA;;EAEE,mBAAmB;AACrB;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA,cAAc;AACd,WAAW;AACX;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,mDAAmD;EACnD,gBAAgB;AAClB;AACA;EACE;;;GAGC;EACD;;;GAGC;EACD,qBAAqB;EACrB,iEAAiE;EACjE,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;AAEnB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yDAAoD;EACpD,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,WAAW;EACX,mBAAmB;AACrB;AACA;;EAEE,WAAW;AACb;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;AACA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,yBAAyB;EACzB;oCACkC;AACpC;AACA;EACE,UAAU;EACV,wDAAwD;EACxD,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,uCAAuC;AACvC;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA,QAAQ;AACR;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;;;;EAIE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,mDAAmD;EACnD,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;AACZ;AACA;EACE,+BAA+B;EAC/B,yDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,yDAAmD;AACrD;AACA;EACE,mDAAmD;EACnD,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;;EAEnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,cAAc,EAAE,WAAW;IAC3B,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,6BAA6B;EAC/B;EACA;;IAEE,eAAe;EACjB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;;EAEnB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;;IAEE,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,0BAA0B;IAC1B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,+CAA+C;EAC/C,gBAAgB,EAAE,gDAAgD;AACpE;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf","sourcesContent":["/* Theme */\n/* * {\n  font-family: sans-serif, \"Poppins\";\n} */\n:root {\n  --Primary-Color-Dark-000639: #000639;\n  --Primary-Color-hover-202E78: #202e78;\n  --Primary-Color-brand-5C6ACA: #5c6aca;\n  --Primary-Color-Light-B3BCF5: #b3bcf5;\n  --Primary-Color-Light-F4F5FA: #f4f5fa;\n  --Secondary-27D4AB: #27d4ab;\n  --Secondary-FFC960: #ffc960;\n  --Secondary-FF55A7: #ff55a7;\n  --Secondary-AE60EB: #ae60eb;\n  --Error-FF0000: #ff0000;\n  --Error-FFB2B2: #ffb2b2;\n  --Secondary-FF55A7: #ff55a7;\n  --Secondary-AE60EB: #ae60eb;\n  --yellow: #ffc960;\n  --yellowlight: #ffe4b0;\n  --teal: #ccfff3;\n  --white: #fff;\n  --gray0: #f9fafb;\n  --gray1: #f4f6f8;\n  --gray2: #dfe4e8;\n  --gray3: #cacdd5;\n  --gray: #919eab;\n  --gray-darklight: #637381;\n  --gray-dark: #454f5b;\n  --gray-darkblack: #212b35;\n  --secondary: #6c757d;\n  --success: #27d4ab;\n  --info: #17a2b8;\n  --warning: #ffc107;\n  --danger: #dc3545;\n  --light: #f8f9fa;\n  --dark: #212b35;\n}\n.form-control:focus {\n  color: var(--bs-body-color);\n  background-color: var(--bs-body-bg);\n  border-color: #86b7fe;\n  outline: 0;\n  box-shadow: none;\n}\n/* .img-fluid{\n  width: 100% !important;\n} */\nplaceholder {\n  color: #919eab !important;\n  font-size: 12px !important;\n}\nbody {\n  background-color: var(--white) !important;\n}\n.bg {\n  background-color: var(--gray1) !important;\n}\n/* Logo */\n.logo {\n  color: var(--white);\n  font-size: 36px;\n  font-weight: 600;\n  text-align: center;\n  padding: 5px;\n  margin-left: 7px;\n}\n/* Right Navbar */\n.rightside-bar {\n  max-width: 249px;\n  border-right: 1px solid #dfe4e8;\n  background: var(--Primary-Color-Dark-000639);\n  height: 100vh;\n}\n.maincontain-width {\n  width: calc(100% - 249px);\n}\n.sidemenuicon {\n  width: 24px;\n  height: 24px;\n}\n.sidemenuicon-bell {\n  width: 20px;\n  height: 18px;\n}\n.sidebar a {\n  text-decoration: none;\n  font-size: 16px;\n  color: var(--white);\n  display: block;\n  padding: 20px;\n  border-radius: 6px;\n  stroke: var(--white);\n  font-weight: 500;\n  fill: var(--white);\n}\n.sidebar a:hover {\n  color: var(--Primary-Color-Dark-000639);\n  background-color: var(--white);\n  border-radius: 6px;\n  fill: var(--Primary-Color-Dark-000639);\n  stroke: var(--Primary-Color-Dark-000639);\n}\n.sidebar .active {\n  color: var(--Primary-Color-Dark-000639);\n  background-color: var(--white);\n  border-radius: 6px;\n  fill: var(--Primary-Color-Dark-000639);\n  stroke: var(--Primary-Color-Dark-000639);\n  padding: 3px 0px;\n}\n.event {\n  fill: none !important;\n}\n.sidebar-notifi {\n  background-color: var(--Secondary-27D4AB);\n  color: #000639;\n  font-size: 11px;\n  font-weight: 600;\n}\n/* Top Nav */\n.topnavbar {\n  /*   height: 70px; */\n  background-color: var(--white);\n  border-bottom: #dadada 1px solid;\n}\n.bell-icon-container {\n  position: relative;\n}\n.topnavbar-icon {\n  width: 28px;\n  height: 28px;\n}\n.topnavbar-icon-bell {\n  width: 28px;\n  height: 28px;\n  cursor: pointer;\n}\n.notification-count {\n  position: absolute;\n  top: -5px;\n  right: -5px;\n  background-color: red;\n  color: white;\n  border-radius: 50%;\n  padding: 3px 6px;\n  font-size: 12px;\n}\n/* Main containt */\n.main-contian {\n  padding: 20px;\n}\n.year-select {\n  width: 120px;\n}\n.total-v-card {\n  /* max-width: 350px;  */\n  width: 100%;\n  \n}\n.total-v-card h6 {\n  color: #454f5b;\n  font-size: 15px;\n  font-weight: 500;\n  margin: 0px;\n}\n.total-v-card h1 {\n  color: #212b35;\n  font-size: 15px;\n  font-weight: 600;\n}\n.bg-organize {\n  border-radius: 6px;\n  background: rgba(197, 253, 240, 0.6);\n  width: 40px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n.organize-icon {\n  width: 28px;\n  height: 28px;\n}\n.revenue-icon {\n  width: 35px;\n  height: 35px;\n}\n.t-event {\n  background: #fae4b9 !important;\n}\n.t-participants {\n  background: #ffd2e7 !important;\n}\n.t-reg-participnts {\n  background: rgba(174, 96, 235, 0.5) !important;\n}\n.t-event-cancel {\n  background: #ddfef6 !important;\n}\n.t-revenue {\n  background: #fae4b8 !important;\n}\n.bashboard-table {\n  border: solid 1px #cacdd5;\n  background: #fff;\n}\n.bashboard-table th {\n  padding: 15px;\n  background: #f4f6f8;\n  color: #637381;\n  font-size: 16px;\n  font-weight: 500;\n}\n.bashboard-table td {\n  padding: 15px;\n}\n.bashboard-table .id {\n  color: #5c6aca;\n  font-size: 14px;\n}\n.bashboard-table .sale {\n  color: #212b35;\n  font-size: 14px;\n}\n.bashboard-table .e-date {\n  color: #637381;\n  font-size: 14px;\n}\n.bashboard-table .e-status {\n  color: #919eab;\n  font-size: 14px;\n}\n.bashboard-table .e-ongoing {\n  color: #27d4ab;\n  font-size: 14px;\n}\n.bashboard-pagination {\n  --bs-pagination-border-width: none;\n  --bs-pagination-hover-bg: none;\n}\n.page-link:focus {\n  z-index: 3;\n  color: none;\n  background-color: none;\n  outline: 0;\n  box-shadow: none;\n}\n.pagination-link ul {\n  position: relative;\n}\n.pagination-link li a {\n  border-radius: 6px;\n  border: 0.5px solid #cacdd5;\n  background: #f9fafb;\n  color: #212b35;\n}\n.pagination-link li a:hover {\n  background: #5c6aca;\n  color: #f4f6f8;\n}\n.pagination-link li:first-child a {\n  border: none;\n  background: none;\n  color: #212b35;\n}\n.pagination-link li:last-child a {\n  border: none;\n  background: none;\n  color: #212b35;\n}\n.logout-icon {\n  position: absolute;\n  width: 215px;\n}\n/* .table-striped > tbody > tr:nth-child(2n+2) > td, .table-striped > tbody > tr:nth-child(2n+2) > th {\n  background-color: #DFE4E8;\n}\n.table-striped > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {\n  background-color: #ffffff !important;\n} */\n/* organizer landing page */\n.create-even {\n  border-radius: 4px;\n  background: #202e78;\n  padding: 6px 16px;\n  align-items: center;\n  font-size: 14px;\n  color: #fff;\n  font-weight: 500;\n}\n.create-even:hover {\n  border-radius: 4px;\n  background: #5c6aca;\n  padding: 6px 16px;\n  align-items: center;\n  font-size: 14px;\n  color: #fff;\n  font-weight: 500;\n}\n.search-bg {\n  background: #f4f6f8;\n  border-top-right-radius: 0px !important;\n  border-bottom-right-radius: 0px !important;\n  font-size: 14px;\n}\n.search-button-bg {\n  background: #f4f6f8;\n  border-top-left-radius: 0px !important;\n  border-bottom-left-radius: 0px !important;\n}\n.search-bg:hover,\n.search-button-bg:hover {\n  background: #f4f6f8;\n}\n.search-bg:active,\n.search-button-bg:active {\n  background: #f4f6f8 !important;\n}\n.search-bg:focus {\n  background: #f4f6f8 !important;\n}\n.search-input {\n  width: 350px !important;\n}\n.all-city {\n  font-size: 12px;\n  color: #000;\n  font-weight: 500;\n}\n.all-city svg {\n  width: 25px;\n  height: 25px;\n}\n/* Hader End */\n/* Banner */\n.topmargin {\n  margin-top: 91px;\n}\n.banner {\n  background: #130929;\n  padding: 40px 0px;\n}\n.swiper {\n  width: 100%;\n  height: 100%;\n}\n.swiper-slide {\n  text-align: center;\n  font-size: 18px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.swiper-slide img {\n  display: block;\n  max-width: 1200px;\n  width: 100%;\n}\n.swiper-pagination-bullet-active {\n  opacity: var(--swiper-pagination-bullet-opacity, 1);\n  background: #fff;\n}\n.swiper-pagination-bullet {\n  width: var(\n    --swiper-pagination-bullet-width,\n    var(--swiper-pagination-bullet-size, 8px)\n  );\n  height: var(\n    --swiper-pagination-bullet-height,\n    var(--swiper-pagination-bullet-size, 8px)\n  );\n  display: inline-block;\n  border-radius: var(--swiper-pagination-bullet-border-radius, 50%);\n  background: #fff;\n  opacity: 0.5;\n}\n.view-text {\n  font-size: 12px !important;\n  font-weight: 400;\n  padding: 7px;\n}\n.card {\n  border-radius: 0.5rem !important;\n}\n.cat-name {\n  font-size: 24px;\n  font-weight: 500;\n  margin-left: 25px;\n\n}\n.event-card-body h6 {\n  font-size: 18px;\n  font-weight: 600;\n}\n.event-card-body .card-text {\n  font-size: 14px;\n  font-weight: 400;\n  color: #757575;\n}\n.event-t-boder {\n  border-top: #ababab dashed 0.5px;\n}\n.event-card-body .card-text-b {\n  color: #4570de;\n}\n.event-buy-price {\n  color: #000;\n  font-size: 18px;\n  font-weight: 600;\n}\n.event-buy-price span {\n  font-size: 14px;\n  font-weight: 600;\n}\n.event-buy-ticket {\n  background: #020202;\n}\n.news-letter {\n  background-image: url(\"../images/new-letter-bg.png\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100% 100%;\n  color: #fff;\n  border-radius: 12px;\n}\n.social-icon a,\nsvg {\n  color: #000;\n}\n.social-icon a:hover {\n  color: #6b21c8;\n}\n.subscribe-letter-text {\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n}\n.subscribe-letter-message {\n  color: #fff;\n  font-size: 16px;\n  padding: 20px 80px;\n  font-weight: 500;\n}\n.subscribe-letter-text input {\n  background: #e2e2e2;\n}\n.subscribe-letter-btn {\n  background: #ff42ca;\n  color: #000;\n  padding: 5px 30px;\n  font-size: 30px;\n}\n.subscribe-letter-btn:hover {\n  background: #6b21c8;\n  color: #000;\n  padding: 5px 30px;\n  font-size: 30px;\n}\n.footer-info {\n  color: #757575;\n  font-size: 14px;\n  height: 76.315px;\n}\n.footer-text,\n.footer-text a {\n  font-size: 14px;\n  color: #757575;\n  text-decoration: none;\n}\n.footer-text-h {\n  font-size: 14px;\n}\n.pre-btn {\n  color: #000;\n  z-index: 1;\n  float: left;\n  width: auto;\n  margin: auto;\n  margin-left: -20px;\n  padding: 0px;\n}\n.pre-btn-bg {\n  background: #dfe4e8;\n  border: 1px solid #dfe4e8;\n}\n.next-btn {\n  color: #000;\n  z-index: 1;\n  float: right;\n  width: auto;\n  margin: auto;\n  margin-right: -20px;\n  padding: 0px;\n}\n/* detail page */\n.game-name {\n  font-size: 24px;\n  font-weight: 600;\n}\n.event-cat {\n  background: #bbd6ff;\n  padding: 5px 10px;\n  font-weight: 500;\n  color: #0c3b83;\n  border-radius: 4px;\n}\n\n.event-cat1 {\n  background: #bbd6ff;\n  padding: 20px 0;\n  font-weight: 500;\n  color: #0c3b83;\n  border-radius: 4px;\n  font-size: 13px;\n  display: inline-block;\n}\n\n.accordion-detail .accordion-icon {\n  background: #bbd6ff;\n  border-radius: 50%;\n  padding: 8px;\n  font-weight: 500;\n}\n.accordion-detail h1 {\n  font-size: 16px;\n  font-weight: 500;\n}\n.accordion-detail .accordion-body {\n  color: #000;\n  font-size: 16px;\n  font-weight: 400;\n}\n.menu-list-group-item {\n  color: #000;\n  font-size: 14px;\n  font-weight: 400;\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: #fbfcff;\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0\n    var(--bs-accordion-border-color);\n}\n.accordion-button:focus {\n  z-index: 3;\n  border-color: var(--bs-accordion-btn-focus-border-color);\n  outline: 0;\n  box-shadow: none;\n}\n.detail-price-card {\n  background: #f4f6f8;\n  border-radius: 8px;\n}\n.detail-price-card .price {\n  background: #fff;\n  border-radius: 8px;\n  padding: 10px 20px;\n}\n.detail-eventinfo-card {\n  background: #fff;\n  border-radius: 8px;\n}\n.detail-price-card .book-btn,\n.detail-eventinfo-card .book-btn {\n  border-radius: 8px;\n  padding: 8px 20px;\n  font-size: 18px;\n  font-weight: 500;\n}\n.detail-price-card .book-btn:hover,\n.detail-eventinfo-card .book-btn:hover {\n  border-radius: 8px;\n  padding: 9px 20px;\n  background: #0d6efd;\n  border: #0d6efd;\n}\n.detail-eventinfo-card h1 {\n  color: #212b35;\n  font-size: 14px;\n  font-weight: 500;\n}\n.detail-eventinfo-card p {\n  color: #637381;\n  font-size: 12px;\n  font-weight: 500;\n}\n/* Select Event before selection page */\n.event-banner-card {\n  border-radius: 6.656px;\n  border: 1px solid #dfe4e8;\n  background: #f9fafb;\n  padding: 10px;\n}\n.event-banner-card h1 {\n  color: #000;\n  font-size: 20px;\n  font-weight: 600;\n}\n.event-banner-card p {\n  color: #636262;\n  font-size: 18px;\n  font-weight: 600;\n}\n.event-type .name {\n  color: #000;\n  font-size: 16px;\n  font-weight: 500;\n}\n.event-type .price {\n  color: #000;\n  font-size: 18px;\n  font-weight: 600;\n}\n.select-event-cat {\n  background: #bbd6ff;\n  padding: 10px 10px 10px 10px;\n  font-weight: 600;\n  color: #0c3b83;\n  border-radius: 4px;\n  font-size: 20px;\n  width: 80px;\n}\n.event-price-summary {\n  font-size: 14px;\n}\n.event-price-summary p {\n  font-size: 11px;\n}\n.select-btn {\n  padding: 10px 40px;\n}\n.accordion-detail .accordion-body {\n  font-size: 16px !important;\n  line-height: 2;\n}\n.user-detailform .card {\n  padding: 5% 5%;\n}\n.user-detailform form,\n.user-detailform .input-group-text,\n.user-detailform .form-select {\n  font-size: 14px;\n}\n.user-detailform input {\n  font-size: 14px;\n}\n/* org */\n.org-left-overbg {\n  background-color: rgba(179, 188, 245, 0.1);\n  border-radius: 8px;\n}\n.org-main-contain {\n  background: #f4f6f8;\n  padding: 2% 3%;\n}\n.org-main-contain .form-control {\n  font-size: 12px;\n  padding: 10px;\n}\n.org-main-contain .form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown),\n.form-floating > .form-control:focus,\n.form-floating > .form-control:not(:placeholder-shown) {\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n}\n.org-main-right {\n  background: #fff;\n  padding: 20px;\n}\n.org-btn-pro {\n  background: #fff;\n  color: #637381;\n  padding: 15px;\n}\n.org-btn-pro:hover {\n  background: #5c6aca;\n  color: #e6e6e6;\n}\n.org-btn-pro.active {\n  background: #5c6aca;\n  color: #e6e6e6;\n}\n.org-left-overbg .accordion-item {\n  color: var(--bs-accordion-color);\n  background: none !important;\n  border: none !important;\n}\n.org-left-overbg .menu-list-group-item {\n  color: #f9fafb;\n  font-size: 14px;\n  font-weight: 400;\n}\n.org-left-overbg .list-group-item {\n  background: none !important;\n  border-bottom: rgba(179, 188, 245, 0.3) solid 0.1px;\n  border-radius: 0px;\n}\n.org-left-overbg .accordion-button {\n  background: none;\n  color: #f9fafb;\n  fill: #fff;\n}\n.org-left-overbg .accordion-button:hover {\n  background: #fff;\n  color: #000;\n  fill: #000;\n}\n.accordion-button:not(.collapsed)::after {\n  /* background-color: #d2153d; */\n  background-image: url(\"../images/chevron-down.svg\");\n  transform: rotate(180deg);\n}\n\n.accordion-button.collapsed::after {\n  background-image: url(\"../images/chevron-down.svg\");\n}\n.org-left-overbg .accordion {\n  --bs-accordion-border-color: var(--bs-border-color);\n  opacity: 0.5;\n}\n.accordion-body .list-group a:hover {\n  color: #5c6aca !important;\n}\n.accordion-body .list-group a.active {\n  color: #5c6aca !important;\n}\n.event-proce {\n  color: #212b35;\n  font-weight: 500;\n  font-size: 14px;\n}\n.event-proce span {\n  padding: 10px 18px;\n  border-radius: 50%;\n  background: #fff;\n  color: #212b35;\n  font-weight: 600;\n  font-size: 16px;\n}\n.event-proce .green-b {\n  border: #27d4ab 2px solid;\n  padding: 10px 17px;\n}\n.event-proce .completed {\n  padding: 10px 14px;\n  border-radius: 50%;\n  background: #27d4ab;\n  color: #212b35;\n  font-weight: 600;\n}\n.select-sport {\n  border: #27d4ab solid 2px;\n  padding: 3px;\n  border-radius: 14px;\n}\n.select-sport img {\n  /* width: 100%; */\n}\n.select-upload .bi::before,\n[class*=\" bi-\"]::before,\n[class^=\"bi-\"]::before {\n  font-weight: 600 !important;\n  font-size: 20px;\n}\n.btn-select {\n  background: #000639;\n  padding: 15px;\n  color: #fff;\n}\n.btn-select:hover {\n  background: #5c6aca;\n  color: #fff;\n}\n\n@media (max-width: 575.98px) {\n  .banner {\n    margin-top: 130px;\n  }\n  .cat-name {\n    font-size: 16px;\n    font-weight: 500;\n    margin-left: 25px;\n\n  }\n  .event-card-body h6 {\n    font-size: 14px;\n    font-weight: 600;\n  }\n  .event-card-body .card-text {\n    font-size: 12px;\n    font-weight: 400;\n    color: #757575;\n  }\n  .search-input {\n    width: 100% !important;\n  }\n  .all-city {\n    font-size: 8px; /*ak-10px;*/\n    color: #000;\n    font-weight: 500;\n    padding: 3px !important;\n    margin: 0px !important;\n  }\n  .all-city svg {\n    width: 20px;\n    height: 20px;\n  }\n  .select-btn {\n    padding: 10px 10px !important;\n  }\n  .detail-price-card .book-btn,\n  .detail-eventinfo-card .book-btn {\n    font-size: 14px;\n  }\n  .accordion-detail .accordion-body {\n    font-size: 12px !important;\n    line-height: 2;\n  }\n  .accordion-detail h1 {\n    font-size: 12px;\n    font-weight: 500;\n  }\n  .game-name {\n    font-size: 14px !important;\n    font-weight: 600;\n  }\n  .running-details {\n    font-size: 14px !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .maincontain-width {\n    width: calc(100% - 197px);\n  }\n  .offcanvas-body .float-end {\n    float: none !important;\n  }\n  .offcanvas-body .d-flex {\n    display: block !important;\n  }\n  .cat-name {\n    font-size: 14px;\n    font-weight: 500;\n    margin-left: 25px;\n\n  }\n  .event-card-body h6 {\n    font-size: 12px;\n    font-weight: 600;\n  }\n  .topmargin {\n    margin-top: 130px;\n  }\n  .subscribe-letter-text {\n    color: #fff;\n    font-size: 18px;\n    font-weight: 600;\n  }\n  .subscribe-letter-message {\n    color: #fff;\n    font-size: 16px;\n    padding: 10px 20px;\n    font-weight: 500;\n  }\n\n  .event-cat1 {\n    background: #bbd6ff;\n    padding: 10px 20px;\n    font-weight: 500;\n    color: #0c3b83;\n    border-radius: 4px;\n    font-size: 13px;\n    /* display: inline-block; */    \n    margin-left: 10px;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .maincontain-width {\n    width: calc(100% - 220px);\n  }\n  .subscribe-letter-text {\n    color: #fff;\n    font-size: 18px;\n    font-weight: 600;\n  }\n  .subscribe-letter-message {\n    color: #fff;\n    font-size: 16px;\n    padding: 10px 20px;\n    font-weight: 500;\n  }\n  .event-banner-card h1 {\n    color: #000;\n    font-size: 14px;\n    font-weight: 600;\n  }\n  .event-banner-card p {\n    color: #636262;\n    font-size: 12px;\n    font-weight: 600;\n  }\n  .event-type .name {\n    color: #000;\n    font-size: 11px;\n    font-weight: 500;\n  }\n  .event-type .price {\n    color: #000;\n    font-size: 14px;\n    font-weight: 600;\n  }\n  .select-event-cat {\n    font-size: 18px;\n    width: 60px;\n  }\n  .select-btn {\n    padding: 10px 20px;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .sidebar a {\n    font-size: 0.875rem;\n    padding: 10px;\n  }\n  .total-v-card h6 {\n    font-size: 0.8rem;\n  }\n  .total-v-card h1 {\n    font-size: 0.875rem;\n  }\n  .main-contian {\n    padding: 10px;\n  }\n  .maincontain-width {\n    width: calc(100% - 249px);\n  }\n}\n@media (max-width: 1399.98px) {\n  .detail-price-card .book-btn,\n  .detail-eventinfo-card .book-btn {\n    font-size: 14px;\n  }\n  .game-name {\n    font-size: 16px;\n    font-weight: 600;\n  }\n  .accordion-detail h1 {\n    font-size: 14px;\n    font-weight: 500;\n  }\n  .accordion-detail .accordion-body {\n    font-size: 14px !important;\n    line-height: 2;\n  }\n}\n\n@media (min-width: 1399.98px) {\n  .topmargin {\n    margin-top: 91px;\n  }\n}\n.otp-form .form-control-01 {\n  display: block;\n  width: 40px;\n  text-align: center;\n  font-size: 1rem;\n  padding: 10px 0px;\n}\n.otp-form .form-control-01:focus-visible,\n.form-control-01:focus {\n  border: #86b7fe 1px solid !important;\n  outline: none;\n}\n\n.editor-container {\n  height: 300px;\n  min-height: 300px;\n  /* max-height: 500px; 25px per line * 5 lines */\n  overflow-y: auto; /* Add scrollbar if content exceeds max height */\n}\n\n.ql-container {\n  /* height: calc(100% - 42px);  */\n  height: 300px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
